import { Inject, Injectable } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { BaseFpxComponentState, BaseFpxFormHelper, HttpRequest } from "@fpx/core";
import { CommonService } from "src/app/common.service";
import { IPopupScreenData } from "src/app/common/models/popup-screen-data.model";
import { ProcessShellService } from "src/app/process-shell/services/process-shell.service";
import { environment } from "src/environments/environment";
import { ResultPageComponent } from "./result-page.component";
import { HttpProviderService } from  '@fpx/core';
import { TransfersResultPageService } from "../transfers-result-page/services/transfers-result-page.service";
import { CustomerService } from "src/app/services/customer.service";
import { PopupComponent } from 'src/app/common/components/popup/popup.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { NativeStorageService } from "src/app/services/mobile/native-storage.service";

declare var entrust: any;

export class ResultPageState extends BaseFpxComponentState {
  showSuggestion: boolean = false;
  resultData: any;
  isAlreadyFav: boolean = false;
  closeBtnLable: string;
}

@Injectable()
export class ResultPageHelper extends BaseFpxFormHelper<ResultPageState>{
  private accountsModules: string[] = ['casa-accounts', 'deposits', 'loans'];
  private cardsModules: string[] = ['debit-card', 'credit-card'];
  private commonModules = new Map<any,any>()
  cardsList: any
 isTapPay: boolean = false;

  constructor(
    public _httpProvider : HttpProviderService,
    private _processShellService: ProcessShellService,
    private _router: Router,
    private _matDialog: MatDialog,
    private _commonService: CommonService,
    private _transfersResultService: TransfersResultPageService,
    private customerService:CustomerService,
    private deviceService: DeviceDetectorService,
     private _nativeStorage: NativeStorageService,
    @Inject(MAT_DIALOG_DATA) private data: IPopupScreenData
  ) {
    super(new ResultPageState());
    // this.state.resultData = this._commonService.isDesktop()?this.data:this._router.getCurrentNavigation()?.extras?.queryParams;
    this.state.resultData = this._router.getCurrentNavigation()?.extras?.queryParams;
    this.commonModules.set('bill-payments','payments')
  }

  public doPreInit(): void {
    this._processShellService.formClassName = this._processShellService.formClassName + " result-info";
    this._processShellService.setFooterVisible(false);
    this._processShellService.setHeaderBackbtnVisible(false);
    // this._processShellService.setTitle('');
    this.cardsList = this.customerService.getAllCards()
  }

  public doPostInit(): void {
    this.closeBtnLable();

  }

  public doDestroy(): void {
    this._processShellService.closeNavigation = []
    this.state.isAlreadyFav = false;
    this._processShellService.resultIconData =  undefined;
    this._processShellService.formClassName = this._processShellService.formClassName.replace(' result-info', '');
    this._transfersResultService.resetTransfersResultPage();
  }

  iconClick(iconData){
    // TEMP FIX
    if(iconData?.icon == 'favourite'){
    //   if(this.state.isAlreadyFav){
    //     return
    // }
    //   this.state.isAlreadyFav = true;p
   
      this._processShellService.resultIconClick.emit({service:iconData?.service,resultData:this.state.resultData});
    }
  }

  onClose() {
    if (this.state.resultData && this.state.resultData.backNavPath) {
      let module = '';
      if (this.accountsModules.includes(this.state.resultData.backNavPath)) module = 'transactions';
      else if (this.cardsModules.includes(this.state.resultData.backNavPath)) module = 'cards';
      else module = this.state.resultData.backNavPath;

      const extras = this._processShellService.getInitialProcess();
      const additionalDetails = extras?.queryParams?.additionalDetails;
      this._processShellService.clearDraftProcess();
      this._commonService.isDesktop()?this._matDialog.closeAll():'';
      let backNavPath;
      if (this.isTapPay == true ) {
         var that = this;
      entrust.checkDefaultNfcApp("",(result: any)=>{
        that.registerPay();
      },(reason: any)=>{
        // that.nfcDefaultAppCheck(cardId);
      });
       
        return
      }
      else if(this.state.resultData.backNavPath instanceof Array){
        backNavPath = this.state.resultData.backNavPath
      }
      else{
        backNavPath = ['home', module]
      }
      this._router.navigate(backNavPath, {
        queryParams: additionalDetails?.queryParams,
        queryParamsHandling: 'preserve'
      });
    } else {
      this._matDialog.closeAll();
      this._router.navigate(['home']);
    }

  }

  registerPay() {
      //var tokenStatus=creditCards.TokenStatus;
      if (this.cardsList?.length < 0) return
      var cardArray = { "CardRefNO": this.cardsList?.[0]?.cardRefNumber, "CardStatus": this.cardsList?.[0]?.status, "CardNumber": this.cardsList?.[0]?.cardNumber };
      let tokenStatus = "REGISTER";
      if (tokenStatus == "REGISTER") {
        //  this.router.navigate(['home','tapnpaytnc']);
        //  this.services.router.navigate(['/home/addProduct']);
        let dialogRef;
        let _data: IPopupScreenData = {
          screenData: {
            cardData: cardArray
          },
          screenTitle: "Terms and Conditions",
          component: 'TapnpayTncFormComponent'
        }
        dialogRef = this._matDialog.open(PopupComponent, {
          width: '100%',
          data: _data,
          panelClass: 'popup-screen'
        });
      }
      else {//To Do}� 
      }
    }

// temp Fix start
  closeBtnLable(){
    if (this.state.resultData && this.state.resultData.backNavPath) {
      let module = '';
      if (this.accountsModules.includes(this.state.resultData.backNavPath)) module = 'transactions';
      else if (this.cardsModules.includes(this.state.resultData.backNavPath)) module = 'cards';
      else module = this.state.resultData.backNavPath;

    // if (this.cardsList?.length == 1 && module == 'cards'&& this._commonService.isHybrid() ){ 
      if (module == 'cards' && this._commonService.isHybrid() && this.deviceService.os.toLowerCase() == 'android' && this.cardsList?.length == 1 ){ 

       
      this._nativeStorage.retriveData('nfcProvisioning').then((value) => {
        var nfcProvision = value;
        if (nfcProvision == "true") {
               entrust.checkCardStatus(this.cardsList?.[0]?.cardRefNumber, (result: any) => {
        // alert("checkCardStatus Result"+result);
        let response = result;
       let cardStatus = response.cardStatus;
       let isCardinWallet = response.isCardinWallet;
       if (cardStatus == "Active" && !isCardinWallet) {
         this.isTapPay = true;
         this.setbackLable('cardsTapAndPay')
       }
       
      }, (reason: any) => {
        let error = reason;
        if (error == "Not_Digitized") {

          this.isTapPay = true;
          this.setbackLable('cardsTapAndPay')

        }
      });
        }
        else {
          console.log("Hiding bt");
        }
      }).catch((reason) => {
        console.log(reason);//hide Tap button
      });
    
       
        //return
      }
      if(this.state.resultData.backNavPath instanceof Array){
        this.setbackLable(this.state.resultData.backNavPath[this.state.resultData.backNavPath.length-1])
      }else{
        this.setbackLable(module)
      }

    }else{
      this.state.closeBtnLable = 'Back To Home'
    }
  }

  setbackLable(module){
    if(module=='transfers'){
      this.state.closeBtnLable = 'Back To Transfers'
    }
    if(module=='transactions'){
      this.state.closeBtnLable = 'Back To Accounts'
    }
    if(module=='cards'){
      this.state.closeBtnLable = 'Back To Cards'
    }
    if(module=='settings'){
      this.state.closeBtnLable = 'Back To Settings'
    }
    if(module=='mailbox'){
      this.state.closeBtnLable = 'Back To Mailbox'
    }
    if(module=='overview'){
      this.state.closeBtnLable = 'Back To Overview'
    }
    if(module=='cardsTapAndPay'){
      this.state.closeBtnLable = 'REGISTER FOR TAP TO PAY'
    }
  }

  // temp Fix end

}
